import { render, staticRenderFns } from "./SetsMainPage.vue?vue&type=template&id=51c2fcad&scoped=true"
import script from "./SetsMainPage.vue?vue&type=script&lang=js"
export * from "./SetsMainPage.vue?vue&type=script&lang=js"
import style0 from "./SetsMainPage.vue?vue&type=style&index=0&id=51c2fcad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2fcad",
  null
  
)

export default component.exports